import { ChartData, Chart as ChartJS, ChartOptions, LineElement, LinearScale, PointElement, Tooltip } from "chart.js";
import React from "react";
import { Scatter } from "react-chartjs-2";

ChartJS.register(LinearScale, PointElement, LineElement, Tooltip);

export interface ScatterChartProps {
	data: ChartData<"scatter">;
	options: ChartOptions<"scatter">;
}

// all we're doing is exporting a configured Scatter chart
const ScatterChart = (props: ScatterChartProps) => {
	return <Scatter data={props.data} options={props.options} />;
};

export default ScatterChart;
